export const bannerDisabledPaths = ["/contact", "/apply-students"];
